
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/5e310d77c71a35520a8427db6e7b95cb.jpeg" 
              alt="Ideevents - Agence événementiel culture africaine" 
              className="h-14 w-auto mb-4"
              title="Ideevents - Agence événementiel culture africaine Nantes"
            />
            <p className="text-gray-300 mb-6 max-w-md">
              Agence de communication et d'événementiel qui conçoit, planifie et met en scène des événements uniques, inclusifs et porteurs de sens.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=61552240756967&locale=fr_FR" className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-full hover:bg-orange-600 transition-colors">
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a href="https://www.instagram.com/ide_events?utm_source=qr&igsh=ZXhud2dta2l3Yjlo" className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-full hover:bg-orange-600 transition-colors">
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/iderosinedeumaga/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-full hover:bg-orange-600 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-line text-white text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-full hover:bg-orange-600 transition-colors">
                <i className="ri-twitter-fill text-white"></i>
              </a>
            </div>
          </div>

          {/* Liens rapides */}
          <div>
            <h4 className="font-semibold mb-4 text-orange-400">Liens rapides</h4>
            <ul className="space-y-2">
              <li><a href="/about" className="text-gray-300 hover:text-orange-400 transition-colors">À propos</a></li>
              <li><a href="/services" className="text-gray-300 hover:text-orange-400 transition-colors">Nos prestations</a></li>
              <li><a href="/projects" className="text-gray-300 hover:text-orange-400 transition-colors">Projets phares</a></li>
              <li><a href="/gallery" className="text-gray-300 hover:text-orange-400 transition-colors">Galerie</a></li>
              <li><a href="/news" className="text-gray-300 hover:text-orange-400 transition-colors">Actualités</a></li>
              <li><a href="/contact" className="text-gray-300 hover:text-orange-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-orange-400">Contact</h4>
            <div className="space-y-2 text-gray-300">
              <p className="flex items-center">
                <i className="ri-mail-line mr-2 text-orange-400"></i>
                contact@ideevents.com
              </p>
              <p className="flex items-center">
                <i className="ri-phone-line mr-2 text-orange-400"></i>
                +33 6 58 86 79 19
              </p>
              <p className="flex items-center">
                <i className="ri-map-pin-line mr-2 text-orange-400"></i>
                Île de Nantes, France
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Ideevents. Tous droits réservés.
          </p>
          <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-orange-400 text-sm transition-colors mt-4 md:mt-0">
            Powered by Wazi Consulting
          </a>
        </div>
      </div>
    </footer>
  );
}
